module.exports = __webpack_public_path__ + "static/media/Spark.c6849586.svg";